import initMultiInputPin from '../modules/multi-input-pin';
import waitForCaptcha from '../modules/wait-for-captcha';

const initialize = () => {
    initMultiInputPin('.eu-panel button[type="submit"]', true);

    waitForCaptcha('#verify_email_form');
};

export default initialize;
